// cspell:ignore NACE
/**
 * Banqup-accepted business activity codes (NACE-BEL 2008, 4-digit class level).
 *
 * Source of truth: the Banqup CMD Partner API rejects any code outside this set
 * with a 400 `BusinessActivityCode` deserialization error. Codes are NACE-BEL
 * 2008 class-level (3-4 digits, leading zeros significant). 5-digit NACE-BEL
 * sub-class codes are NOT accepted.
 *
 * Lookup a company's code via the KBO register: https://kbopub.economie.fgov.be
 * Reference: https://statbel.fgov.be/en/open-data/nace-bel-2008-classification
 */
export var EBanqupBusinessActivityCode;
(function (EBanqupBusinessActivityCode) {
    EBanqupBusinessActivityCode["Code011"] = "011";
    EBanqupBusinessActivityCode["Code0111"] = "0111";
    EBanqupBusinessActivityCode["Code0112"] = "0112";
    EBanqupBusinessActivityCode["Code0113"] = "0113";
    EBanqupBusinessActivityCode["Code0114"] = "0114";
    EBanqupBusinessActivityCode["Code0115"] = "0115";
    EBanqupBusinessActivityCode["Code0116"] = "0116";
    EBanqupBusinessActivityCode["Code0119"] = "0119";
    EBanqupBusinessActivityCode["Code012"] = "012";
    EBanqupBusinessActivityCode["Code0121"] = "0121";
    EBanqupBusinessActivityCode["Code0122"] = "0122";
    EBanqupBusinessActivityCode["Code0123"] = "0123";
    EBanqupBusinessActivityCode["Code0124"] = "0124";
    EBanqupBusinessActivityCode["Code0125"] = "0125";
    EBanqupBusinessActivityCode["Code0126"] = "0126";
    EBanqupBusinessActivityCode["Code0127"] = "0127";
    EBanqupBusinessActivityCode["Code0128"] = "0128";
    EBanqupBusinessActivityCode["Code0129"] = "0129";
    EBanqupBusinessActivityCode["Code013"] = "013";
    EBanqupBusinessActivityCode["Code0130"] = "0130";
    EBanqupBusinessActivityCode["Code014"] = "014";
    EBanqupBusinessActivityCode["Code0141"] = "0141";
    EBanqupBusinessActivityCode["Code0142"] = "0142";
    EBanqupBusinessActivityCode["Code0143"] = "0143";
    EBanqupBusinessActivityCode["Code0144"] = "0144";
    EBanqupBusinessActivityCode["Code0145"] = "0145";
    EBanqupBusinessActivityCode["Code0146"] = "0146";
    EBanqupBusinessActivityCode["Code0147"] = "0147";
    EBanqupBusinessActivityCode["Code0149"] = "0149";
    EBanqupBusinessActivityCode["Code015"] = "015";
    EBanqupBusinessActivityCode["Code0150"] = "0150";
    EBanqupBusinessActivityCode["Code016"] = "016";
    EBanqupBusinessActivityCode["Code0161"] = "0161";
    EBanqupBusinessActivityCode["Code0162"] = "0162";
    EBanqupBusinessActivityCode["Code0163"] = "0163";
    EBanqupBusinessActivityCode["Code0164"] = "0164";
    EBanqupBusinessActivityCode["Code017"] = "017";
    EBanqupBusinessActivityCode["Code0170"] = "0170";
    EBanqupBusinessActivityCode["Code021"] = "021";
    EBanqupBusinessActivityCode["Code0210"] = "0210";
    EBanqupBusinessActivityCode["Code0220"] = "0220";
    EBanqupBusinessActivityCode["Code0230"] = "0230";
    EBanqupBusinessActivityCode["Code0240"] = "0240";
    EBanqupBusinessActivityCode["Code031"] = "031";
    EBanqupBusinessActivityCode["Code0311"] = "0311";
    EBanqupBusinessActivityCode["Code0312"] = "0312";
    EBanqupBusinessActivityCode["Code032"] = "032";
    EBanqupBusinessActivityCode["Code0321"] = "0321";
    EBanqupBusinessActivityCode["Code0322"] = "0322";
    EBanqupBusinessActivityCode["Code051"] = "051";
    EBanqupBusinessActivityCode["Code0510"] = "0510";
    EBanqupBusinessActivityCode["Code052"] = "052";
    EBanqupBusinessActivityCode["Code0520"] = "0520";
    EBanqupBusinessActivityCode["Code061"] = "061";
    EBanqupBusinessActivityCode["Code0610"] = "0610";
    EBanqupBusinessActivityCode["Code062"] = "062";
    EBanqupBusinessActivityCode["Code0620"] = "0620";
    EBanqupBusinessActivityCode["Code071"] = "071";
    EBanqupBusinessActivityCode["Code0710"] = "0710";
    EBanqupBusinessActivityCode["Code072"] = "072";
    EBanqupBusinessActivityCode["Code0721"] = "0721";
    EBanqupBusinessActivityCode["Code0729"] = "0729";
    EBanqupBusinessActivityCode["Code081"] = "081";
    EBanqupBusinessActivityCode["Code0811"] = "0811";
    EBanqupBusinessActivityCode["Code0812"] = "0812";
    EBanqupBusinessActivityCode["Code089"] = "089";
    EBanqupBusinessActivityCode["Code0891"] = "0891";
    EBanqupBusinessActivityCode["Code0892"] = "0892";
    EBanqupBusinessActivityCode["Code0893"] = "0893";
    EBanqupBusinessActivityCode["Code0899"] = "0899";
    EBanqupBusinessActivityCode["Code091"] = "091";
    EBanqupBusinessActivityCode["Code0910"] = "0910";
    EBanqupBusinessActivityCode["Code0990"] = "0990";
    EBanqupBusinessActivityCode["Code101"] = "101";
    EBanqupBusinessActivityCode["Code1011"] = "1011";
    EBanqupBusinessActivityCode["Code1012"] = "1012";
    EBanqupBusinessActivityCode["Code1013"] = "1013";
    EBanqupBusinessActivityCode["Code102"] = "102";
    EBanqupBusinessActivityCode["Code1020"] = "1020";
    EBanqupBusinessActivityCode["Code103"] = "103";
    EBanqupBusinessActivityCode["Code1031"] = "1031";
    EBanqupBusinessActivityCode["Code1032"] = "1032";
    EBanqupBusinessActivityCode["Code1039"] = "1039";
    EBanqupBusinessActivityCode["Code104"] = "104";
    EBanqupBusinessActivityCode["Code1041"] = "1041";
    EBanqupBusinessActivityCode["Code1042"] = "1042";
    EBanqupBusinessActivityCode["Code105"] = "105";
    EBanqupBusinessActivityCode["Code1051"] = "1051";
    EBanqupBusinessActivityCode["Code1052"] = "1052";
    EBanqupBusinessActivityCode["Code106"] = "106";
    EBanqupBusinessActivityCode["Code1061"] = "1061";
    EBanqupBusinessActivityCode["Code1062"] = "1062";
    EBanqupBusinessActivityCode["Code107"] = "107";
    EBanqupBusinessActivityCode["Code1071"] = "1071";
    EBanqupBusinessActivityCode["Code1072"] = "1072";
    EBanqupBusinessActivityCode["Code1073"] = "1073";
    EBanqupBusinessActivityCode["Code108"] = "108";
    EBanqupBusinessActivityCode["Code1081"] = "1081";
    EBanqupBusinessActivityCode["Code1082"] = "1082";
    EBanqupBusinessActivityCode["Code1083"] = "1083";
    EBanqupBusinessActivityCode["Code1084"] = "1084";
    EBanqupBusinessActivityCode["Code1085"] = "1085";
    EBanqupBusinessActivityCode["Code1086"] = "1086";
    EBanqupBusinessActivityCode["Code1089"] = "1089";
    EBanqupBusinessActivityCode["Code109"] = "109";
    EBanqupBusinessActivityCode["Code1091"] = "1091";
    EBanqupBusinessActivityCode["Code1092"] = "1092";
    EBanqupBusinessActivityCode["Code110"] = "110";
    EBanqupBusinessActivityCode["Code1101"] = "1101";
    EBanqupBusinessActivityCode["Code1102"] = "1102";
    EBanqupBusinessActivityCode["Code1103"] = "1103";
    EBanqupBusinessActivityCode["Code1104"] = "1104";
    EBanqupBusinessActivityCode["Code1105"] = "1105";
    EBanqupBusinessActivityCode["Code1106"] = "1106";
    EBanqupBusinessActivityCode["Code1107"] = "1107";
    EBanqupBusinessActivityCode["Code120"] = "120";
    EBanqupBusinessActivityCode["Code1200"] = "1200";
    EBanqupBusinessActivityCode["Code131"] = "131";
    EBanqupBusinessActivityCode["Code1310"] = "1310";
    EBanqupBusinessActivityCode["Code132"] = "132";
    EBanqupBusinessActivityCode["Code1320"] = "1320";
    EBanqupBusinessActivityCode["Code133"] = "133";
    EBanqupBusinessActivityCode["Code1330"] = "1330";
    EBanqupBusinessActivityCode["Code139"] = "139";
    EBanqupBusinessActivityCode["Code1391"] = "1391";
    EBanqupBusinessActivityCode["Code1392"] = "1392";
    EBanqupBusinessActivityCode["Code1393"] = "1393";
    EBanqupBusinessActivityCode["Code1394"] = "1394";
    EBanqupBusinessActivityCode["Code1395"] = "1395";
    EBanqupBusinessActivityCode["Code1396"] = "1396";
    EBanqupBusinessActivityCode["Code1399"] = "1399";
    EBanqupBusinessActivityCode["Code141"] = "141";
    EBanqupBusinessActivityCode["Code1411"] = "1411";
    EBanqupBusinessActivityCode["Code1412"] = "1412";
    EBanqupBusinessActivityCode["Code1413"] = "1413";
    EBanqupBusinessActivityCode["Code1414"] = "1414";
    EBanqupBusinessActivityCode["Code1419"] = "1419";
    EBanqupBusinessActivityCode["Code142"] = "142";
    EBanqupBusinessActivityCode["Code1420"] = "1420";
    EBanqupBusinessActivityCode["Code143"] = "143";
    EBanqupBusinessActivityCode["Code1431"] = "1431";
    EBanqupBusinessActivityCode["Code1439"] = "1439";
    EBanqupBusinessActivityCode["Code151"] = "151";
    EBanqupBusinessActivityCode["Code1511"] = "1511";
    EBanqupBusinessActivityCode["Code1512"] = "1512";
    EBanqupBusinessActivityCode["Code152"] = "152";
    EBanqupBusinessActivityCode["Code1520"] = "1520";
    EBanqupBusinessActivityCode["Code161"] = "161";
    EBanqupBusinessActivityCode["Code1610"] = "1610";
    EBanqupBusinessActivityCode["Code162"] = "162";
    EBanqupBusinessActivityCode["Code1621"] = "1621";
    EBanqupBusinessActivityCode["Code1622"] = "1622";
    EBanqupBusinessActivityCode["Code1623"] = "1623";
    EBanqupBusinessActivityCode["Code1624"] = "1624";
    EBanqupBusinessActivityCode["Code1629"] = "1629";
    EBanqupBusinessActivityCode["Code171"] = "171";
    EBanqupBusinessActivityCode["Code1711"] = "1711";
    EBanqupBusinessActivityCode["Code1712"] = "1712";
    EBanqupBusinessActivityCode["Code172"] = "172";
    EBanqupBusinessActivityCode["Code1721"] = "1721";
    EBanqupBusinessActivityCode["Code1722"] = "1722";
    EBanqupBusinessActivityCode["Code1723"] = "1723";
    EBanqupBusinessActivityCode["Code1724"] = "1724";
    EBanqupBusinessActivityCode["Code1729"] = "1729";
    EBanqupBusinessActivityCode["Code181"] = "181";
    EBanqupBusinessActivityCode["Code1811"] = "1811";
    EBanqupBusinessActivityCode["Code1812"] = "1812";
    EBanqupBusinessActivityCode["Code1813"] = "1813";
    EBanqupBusinessActivityCode["Code1814"] = "1814";
    EBanqupBusinessActivityCode["Code182"] = "182";
    EBanqupBusinessActivityCode["Code1820"] = "1820";
    EBanqupBusinessActivityCode["Code191"] = "191";
    EBanqupBusinessActivityCode["Code1910"] = "1910";
    EBanqupBusinessActivityCode["Code192"] = "192";
    EBanqupBusinessActivityCode["Code1920"] = "1920";
    EBanqupBusinessActivityCode["Code201"] = "201";
    EBanqupBusinessActivityCode["Code2011"] = "2011";
    EBanqupBusinessActivityCode["Code2012"] = "2012";
    EBanqupBusinessActivityCode["Code2013"] = "2013";
    EBanqupBusinessActivityCode["Code2014"] = "2014";
    EBanqupBusinessActivityCode["Code2015"] = "2015";
    EBanqupBusinessActivityCode["Code2016"] = "2016";
    EBanqupBusinessActivityCode["Code2017"] = "2017";
    EBanqupBusinessActivityCode["Code202"] = "202";
    EBanqupBusinessActivityCode["Code2020"] = "2020";
    EBanqupBusinessActivityCode["Code203"] = "203";
    EBanqupBusinessActivityCode["Code2030"] = "2030";
    EBanqupBusinessActivityCode["Code204"] = "204";
    EBanqupBusinessActivityCode["Code2041"] = "2041";
    EBanqupBusinessActivityCode["Code2042"] = "2042";
    EBanqupBusinessActivityCode["Code205"] = "205";
    EBanqupBusinessActivityCode["Code2051"] = "2051";
    EBanqupBusinessActivityCode["Code2052"] = "2052";
    EBanqupBusinessActivityCode["Code2053"] = "2053";
    EBanqupBusinessActivityCode["Code2059"] = "2059";
    EBanqupBusinessActivityCode["Code206"] = "206";
    EBanqupBusinessActivityCode["Code2060"] = "2060";
    EBanqupBusinessActivityCode["Code211"] = "211";
    EBanqupBusinessActivityCode["Code2110"] = "2110";
    EBanqupBusinessActivityCode["Code212"] = "212";
    EBanqupBusinessActivityCode["Code2120"] = "2120";
    EBanqupBusinessActivityCode["Code221"] = "221";
    EBanqupBusinessActivityCode["Code2211"] = "2211";
    EBanqupBusinessActivityCode["Code2219"] = "2219";
    EBanqupBusinessActivityCode["Code222"] = "222";
    EBanqupBusinessActivityCode["Code2221"] = "2221";
    EBanqupBusinessActivityCode["Code2222"] = "2222";
    EBanqupBusinessActivityCode["Code2223"] = "2223";
    EBanqupBusinessActivityCode["Code2229"] = "2229";
    EBanqupBusinessActivityCode["Code231"] = "231";
    EBanqupBusinessActivityCode["Code2311"] = "2311";
    EBanqupBusinessActivityCode["Code2312"] = "2312";
    EBanqupBusinessActivityCode["Code2313"] = "2313";
    EBanqupBusinessActivityCode["Code2314"] = "2314";
    EBanqupBusinessActivityCode["Code2319"] = "2319";
    EBanqupBusinessActivityCode["Code232"] = "232";
    EBanqupBusinessActivityCode["Code2320"] = "2320";
    EBanqupBusinessActivityCode["Code233"] = "233";
    EBanqupBusinessActivityCode["Code2331"] = "2331";
    EBanqupBusinessActivityCode["Code2332"] = "2332";
    EBanqupBusinessActivityCode["Code234"] = "234";
    EBanqupBusinessActivityCode["Code2341"] = "2341";
    EBanqupBusinessActivityCode["Code2342"] = "2342";
    EBanqupBusinessActivityCode["Code2343"] = "2343";
    EBanqupBusinessActivityCode["Code2344"] = "2344";
    EBanqupBusinessActivityCode["Code2349"] = "2349";
    EBanqupBusinessActivityCode["Code235"] = "235";
    EBanqupBusinessActivityCode["Code2351"] = "2351";
    EBanqupBusinessActivityCode["Code2352"] = "2352";
    EBanqupBusinessActivityCode["Code236"] = "236";
    EBanqupBusinessActivityCode["Code2361"] = "2361";
    EBanqupBusinessActivityCode["Code2362"] = "2362";
    EBanqupBusinessActivityCode["Code2363"] = "2363";
    EBanqupBusinessActivityCode["Code2364"] = "2364";
    EBanqupBusinessActivityCode["Code2365"] = "2365";
    EBanqupBusinessActivityCode["Code2369"] = "2369";
    EBanqupBusinessActivityCode["Code237"] = "237";
    EBanqupBusinessActivityCode["Code2370"] = "2370";
    EBanqupBusinessActivityCode["Code239"] = "239";
    EBanqupBusinessActivityCode["Code2391"] = "2391";
    EBanqupBusinessActivityCode["Code2399"] = "2399";
    EBanqupBusinessActivityCode["Code241"] = "241";
    EBanqupBusinessActivityCode["Code2410"] = "2410";
    EBanqupBusinessActivityCode["Code242"] = "242";
    EBanqupBusinessActivityCode["Code2420"] = "2420";
    EBanqupBusinessActivityCode["Code243"] = "243";
    EBanqupBusinessActivityCode["Code2431"] = "2431";
    EBanqupBusinessActivityCode["Code2432"] = "2432";
    EBanqupBusinessActivityCode["Code2433"] = "2433";
    EBanqupBusinessActivityCode["Code2434"] = "2434";
    EBanqupBusinessActivityCode["Code244"] = "244";
    EBanqupBusinessActivityCode["Code2441"] = "2441";
    EBanqupBusinessActivityCode["Code2442"] = "2442";
    EBanqupBusinessActivityCode["Code2443"] = "2443";
    EBanqupBusinessActivityCode["Code2444"] = "2444";
    EBanqupBusinessActivityCode["Code2445"] = "2445";
    EBanqupBusinessActivityCode["Code2446"] = "2446";
    EBanqupBusinessActivityCode["Code245"] = "245";
    EBanqupBusinessActivityCode["Code2451"] = "2451";
    EBanqupBusinessActivityCode["Code2452"] = "2452";
    EBanqupBusinessActivityCode["Code2453"] = "2453";
    EBanqupBusinessActivityCode["Code2454"] = "2454";
    EBanqupBusinessActivityCode["Code251"] = "251";
    EBanqupBusinessActivityCode["Code2511"] = "2511";
    EBanqupBusinessActivityCode["Code2512"] = "2512";
    EBanqupBusinessActivityCode["Code252"] = "252";
    EBanqupBusinessActivityCode["Code2521"] = "2521";
    EBanqupBusinessActivityCode["Code2529"] = "2529";
    EBanqupBusinessActivityCode["Code253"] = "253";
    EBanqupBusinessActivityCode["Code2530"] = "2530";
    EBanqupBusinessActivityCode["Code254"] = "254";
    EBanqupBusinessActivityCode["Code2540"] = "2540";
    EBanqupBusinessActivityCode["Code255"] = "255";
    EBanqupBusinessActivityCode["Code2550"] = "2550";
    EBanqupBusinessActivityCode["Code256"] = "256";
    EBanqupBusinessActivityCode["Code2561"] = "2561";
    EBanqupBusinessActivityCode["Code2562"] = "2562";
    EBanqupBusinessActivityCode["Code257"] = "257";
    EBanqupBusinessActivityCode["Code2571"] = "2571";
    EBanqupBusinessActivityCode["Code2572"] = "2572";
    EBanqupBusinessActivityCode["Code2573"] = "2573";
    EBanqupBusinessActivityCode["Code259"] = "259";
    EBanqupBusinessActivityCode["Code2591"] = "2591";
    EBanqupBusinessActivityCode["Code2592"] = "2592";
    EBanqupBusinessActivityCode["Code2593"] = "2593";
    EBanqupBusinessActivityCode["Code2594"] = "2594";
    EBanqupBusinessActivityCode["Code2599"] = "2599";
    EBanqupBusinessActivityCode["Code261"] = "261";
    EBanqupBusinessActivityCode["Code2611"] = "2611";
    EBanqupBusinessActivityCode["Code2612"] = "2612";
    EBanqupBusinessActivityCode["Code262"] = "262";
    EBanqupBusinessActivityCode["Code2620"] = "2620";
    EBanqupBusinessActivityCode["Code263"] = "263";
    EBanqupBusinessActivityCode["Code2630"] = "2630";
    EBanqupBusinessActivityCode["Code264"] = "264";
    EBanqupBusinessActivityCode["Code2640"] = "2640";
    EBanqupBusinessActivityCode["Code265"] = "265";
    EBanqupBusinessActivityCode["Code2651"] = "2651";
    EBanqupBusinessActivityCode["Code2652"] = "2652";
    EBanqupBusinessActivityCode["Code266"] = "266";
    EBanqupBusinessActivityCode["Code2660"] = "2660";
    EBanqupBusinessActivityCode["Code267"] = "267";
    EBanqupBusinessActivityCode["Code2670"] = "2670";
    EBanqupBusinessActivityCode["Code268"] = "268";
    EBanqupBusinessActivityCode["Code2680"] = "2680";
    EBanqupBusinessActivityCode["Code271"] = "271";
    EBanqupBusinessActivityCode["Code2711"] = "2711";
    EBanqupBusinessActivityCode["Code2712"] = "2712";
    EBanqupBusinessActivityCode["Code272"] = "272";
    EBanqupBusinessActivityCode["Code2720"] = "2720";
    EBanqupBusinessActivityCode["Code273"] = "273";
    EBanqupBusinessActivityCode["Code2731"] = "2731";
    EBanqupBusinessActivityCode["Code2732"] = "2732";
    EBanqupBusinessActivityCode["Code2733"] = "2733";
    EBanqupBusinessActivityCode["Code274"] = "274";
    EBanqupBusinessActivityCode["Code2740"] = "2740";
    EBanqupBusinessActivityCode["Code275"] = "275";
    EBanqupBusinessActivityCode["Code2751"] = "2751";
    EBanqupBusinessActivityCode["Code2752"] = "2752";
    EBanqupBusinessActivityCode["Code279"] = "279";
    EBanqupBusinessActivityCode["Code2790"] = "2790";
    EBanqupBusinessActivityCode["Code281"] = "281";
    EBanqupBusinessActivityCode["Code2811"] = "2811";
    EBanqupBusinessActivityCode["Code2812"] = "2812";
    EBanqupBusinessActivityCode["Code2813"] = "2813";
    EBanqupBusinessActivityCode["Code2814"] = "2814";
    EBanqupBusinessActivityCode["Code2815"] = "2815";
    EBanqupBusinessActivityCode["Code282"] = "282";
    EBanqupBusinessActivityCode["Code2821"] = "2821";
    EBanqupBusinessActivityCode["Code2822"] = "2822";
    EBanqupBusinessActivityCode["Code2823"] = "2823";
    EBanqupBusinessActivityCode["Code2824"] = "2824";
    EBanqupBusinessActivityCode["Code2825"] = "2825";
    EBanqupBusinessActivityCode["Code2829"] = "2829";
    EBanqupBusinessActivityCode["Code283"] = "283";
    EBanqupBusinessActivityCode["Code2830"] = "2830";
    EBanqupBusinessActivityCode["Code284"] = "284";
    EBanqupBusinessActivityCode["Code2841"] = "2841";
    EBanqupBusinessActivityCode["Code2849"] = "2849";
    EBanqupBusinessActivityCode["Code289"] = "289";
    EBanqupBusinessActivityCode["Code2891"] = "2891";
    EBanqupBusinessActivityCode["Code2892"] = "2892";
    EBanqupBusinessActivityCode["Code2893"] = "2893";
    EBanqupBusinessActivityCode["Code2894"] = "2894";
    EBanqupBusinessActivityCode["Code2895"] = "2895";
    EBanqupBusinessActivityCode["Code2896"] = "2896";
    EBanqupBusinessActivityCode["Code2899"] = "2899";
    EBanqupBusinessActivityCode["Code291"] = "291";
    EBanqupBusinessActivityCode["Code2910"] = "2910";
    EBanqupBusinessActivityCode["Code292"] = "292";
    EBanqupBusinessActivityCode["Code2920"] = "2920";
    EBanqupBusinessActivityCode["Code293"] = "293";
    EBanqupBusinessActivityCode["Code2931"] = "2931";
    EBanqupBusinessActivityCode["Code2932"] = "2932";
    EBanqupBusinessActivityCode["Code301"] = "301";
    EBanqupBusinessActivityCode["Code3011"] = "3011";
    EBanqupBusinessActivityCode["Code3012"] = "3012";
    EBanqupBusinessActivityCode["Code302"] = "302";
    EBanqupBusinessActivityCode["Code3020"] = "3020";
    EBanqupBusinessActivityCode["Code303"] = "303";
    EBanqupBusinessActivityCode["Code3030"] = "3030";
    EBanqupBusinessActivityCode["Code304"] = "304";
    EBanqupBusinessActivityCode["Code3040"] = "3040";
    EBanqupBusinessActivityCode["Code309"] = "309";
    EBanqupBusinessActivityCode["Code3091"] = "3091";
    EBanqupBusinessActivityCode["Code3092"] = "3092";
    EBanqupBusinessActivityCode["Code3099"] = "3099";
    EBanqupBusinessActivityCode["Code310"] = "310";
    EBanqupBusinessActivityCode["Code3101"] = "3101";
    EBanqupBusinessActivityCode["Code3102"] = "3102";
    EBanqupBusinessActivityCode["Code3103"] = "3103";
    EBanqupBusinessActivityCode["Code3109"] = "3109";
    EBanqupBusinessActivityCode["Code321"] = "321";
    EBanqupBusinessActivityCode["Code3211"] = "3211";
    EBanqupBusinessActivityCode["Code3212"] = "3212";
    EBanqupBusinessActivityCode["Code3213"] = "3213";
    EBanqupBusinessActivityCode["Code322"] = "322";
    EBanqupBusinessActivityCode["Code3220"] = "3220";
    EBanqupBusinessActivityCode["Code323"] = "323";
    EBanqupBusinessActivityCode["Code3230"] = "3230";
    EBanqupBusinessActivityCode["Code324"] = "324";
    EBanqupBusinessActivityCode["Code3240"] = "3240";
    EBanqupBusinessActivityCode["Code325"] = "325";
    EBanqupBusinessActivityCode["Code3250"] = "3250";
    EBanqupBusinessActivityCode["Code329"] = "329";
    EBanqupBusinessActivityCode["Code3291"] = "3291";
    EBanqupBusinessActivityCode["Code3299"] = "3299";
    EBanqupBusinessActivityCode["Code331"] = "331";
    EBanqupBusinessActivityCode["Code3311"] = "3311";
    EBanqupBusinessActivityCode["Code3312"] = "3312";
    EBanqupBusinessActivityCode["Code3313"] = "3313";
    EBanqupBusinessActivityCode["Code3314"] = "3314";
    EBanqupBusinessActivityCode["Code3315"] = "3315";
    EBanqupBusinessActivityCode["Code3316"] = "3316";
    EBanqupBusinessActivityCode["Code3317"] = "3317";
    EBanqupBusinessActivityCode["Code3319"] = "3319";
    EBanqupBusinessActivityCode["Code332"] = "332";
    EBanqupBusinessActivityCode["Code3320"] = "3320";
    EBanqupBusinessActivityCode["Code351"] = "351";
    EBanqupBusinessActivityCode["Code3511"] = "3511";
    EBanqupBusinessActivityCode["Code3512"] = "3512";
    EBanqupBusinessActivityCode["Code3513"] = "3513";
    EBanqupBusinessActivityCode["Code3514"] = "3514";
    EBanqupBusinessActivityCode["Code352"] = "352";
    EBanqupBusinessActivityCode["Code3521"] = "3521";
    EBanqupBusinessActivityCode["Code3522"] = "3522";
    EBanqupBusinessActivityCode["Code3523"] = "3523";
    EBanqupBusinessActivityCode["Code353"] = "353";
    EBanqupBusinessActivityCode["Code3530"] = "3530";
    EBanqupBusinessActivityCode["Code360"] = "360";
    EBanqupBusinessActivityCode["Code3600"] = "3600";
    EBanqupBusinessActivityCode["Code370"] = "370";
    EBanqupBusinessActivityCode["Code3700"] = "3700";
    EBanqupBusinessActivityCode["Code381"] = "381";
    EBanqupBusinessActivityCode["Code3811"] = "3811";
    EBanqupBusinessActivityCode["Code3812"] = "3812";
    EBanqupBusinessActivityCode["Code382"] = "382";
    EBanqupBusinessActivityCode["Code3821"] = "3821";
    EBanqupBusinessActivityCode["Code3822"] = "3822";
    EBanqupBusinessActivityCode["Code383"] = "383";
    EBanqupBusinessActivityCode["Code3831"] = "3831";
    EBanqupBusinessActivityCode["Code3832"] = "3832";
    EBanqupBusinessActivityCode["Code390"] = "390";
    EBanqupBusinessActivityCode["Code3900"] = "3900";
    EBanqupBusinessActivityCode["Code411"] = "411";
    EBanqupBusinessActivityCode["Code4110"] = "4110";
    EBanqupBusinessActivityCode["Code412"] = "412";
    EBanqupBusinessActivityCode["Code4120"] = "4120";
    EBanqupBusinessActivityCode["Code421"] = "421";
    EBanqupBusinessActivityCode["Code4211"] = "4211";
    EBanqupBusinessActivityCode["Code4212"] = "4212";
    EBanqupBusinessActivityCode["Code4213"] = "4213";
    EBanqupBusinessActivityCode["Code422"] = "422";
    EBanqupBusinessActivityCode["Code4221"] = "4221";
    EBanqupBusinessActivityCode["Code4222"] = "4222";
    EBanqupBusinessActivityCode["Code429"] = "429";
    EBanqupBusinessActivityCode["Code4291"] = "4291";
    EBanqupBusinessActivityCode["Code4299"] = "4299";
    EBanqupBusinessActivityCode["Code431"] = "431";
    EBanqupBusinessActivityCode["Code4311"] = "4311";
    EBanqupBusinessActivityCode["Code4312"] = "4312";
    EBanqupBusinessActivityCode["Code4313"] = "4313";
    EBanqupBusinessActivityCode["Code432"] = "432";
    EBanqupBusinessActivityCode["Code4321"] = "4321";
    EBanqupBusinessActivityCode["Code4322"] = "4322";
    EBanqupBusinessActivityCode["Code4329"] = "4329";
    EBanqupBusinessActivityCode["Code433"] = "433";
    EBanqupBusinessActivityCode["Code4331"] = "4331";
    EBanqupBusinessActivityCode["Code4332"] = "4332";
    EBanqupBusinessActivityCode["Code4333"] = "4333";
    EBanqupBusinessActivityCode["Code4334"] = "4334";
    EBanqupBusinessActivityCode["Code4339"] = "4339";
    EBanqupBusinessActivityCode["Code439"] = "439";
    EBanqupBusinessActivityCode["Code4391"] = "4391";
    EBanqupBusinessActivityCode["Code4399"] = "4399";
    EBanqupBusinessActivityCode["Code451"] = "451";
    EBanqupBusinessActivityCode["Code4511"] = "4511";
    EBanqupBusinessActivityCode["Code4519"] = "4519";
    EBanqupBusinessActivityCode["Code452"] = "452";
    EBanqupBusinessActivityCode["Code4520"] = "4520";
    EBanqupBusinessActivityCode["Code453"] = "453";
    EBanqupBusinessActivityCode["Code4531"] = "4531";
    EBanqupBusinessActivityCode["Code4532"] = "4532";
    EBanqupBusinessActivityCode["Code454"] = "454";
    EBanqupBusinessActivityCode["Code4540"] = "4540";
    EBanqupBusinessActivityCode["Code461"] = "461";
    EBanqupBusinessActivityCode["Code4611"] = "4611";
    EBanqupBusinessActivityCode["Code4612"] = "4612";
    EBanqupBusinessActivityCode["Code4613"] = "4613";
    EBanqupBusinessActivityCode["Code4614"] = "4614";
    EBanqupBusinessActivityCode["Code4615"] = "4615";
    EBanqupBusinessActivityCode["Code4616"] = "4616";
    EBanqupBusinessActivityCode["Code4617"] = "4617";
    EBanqupBusinessActivityCode["Code4618"] = "4618";
    EBanqupBusinessActivityCode["Code4619"] = "4619";
    EBanqupBusinessActivityCode["Code462"] = "462";
    EBanqupBusinessActivityCode["Code4621"] = "4621";
    EBanqupBusinessActivityCode["Code4622"] = "4622";
    EBanqupBusinessActivityCode["Code4623"] = "4623";
    EBanqupBusinessActivityCode["Code4624"] = "4624";
    EBanqupBusinessActivityCode["Code463"] = "463";
    EBanqupBusinessActivityCode["Code4631"] = "4631";
    EBanqupBusinessActivityCode["Code4632"] = "4632";
    EBanqupBusinessActivityCode["Code4633"] = "4633";
    EBanqupBusinessActivityCode["Code4634"] = "4634";
    EBanqupBusinessActivityCode["Code4635"] = "4635";
    EBanqupBusinessActivityCode["Code4636"] = "4636";
    EBanqupBusinessActivityCode["Code4637"] = "4637";
    EBanqupBusinessActivityCode["Code4638"] = "4638";
    EBanqupBusinessActivityCode["Code4639"] = "4639";
    EBanqupBusinessActivityCode["Code464"] = "464";
    EBanqupBusinessActivityCode["Code4641"] = "4641";
    EBanqupBusinessActivityCode["Code4642"] = "4642";
    EBanqupBusinessActivityCode["Code4643"] = "4643";
    EBanqupBusinessActivityCode["Code4644"] = "4644";
    EBanqupBusinessActivityCode["Code4645"] = "4645";
    EBanqupBusinessActivityCode["Code4646"] = "4646";
    EBanqupBusinessActivityCode["Code4647"] = "4647";
    EBanqupBusinessActivityCode["Code4648"] = "4648";
    EBanqupBusinessActivityCode["Code4649"] = "4649";
    EBanqupBusinessActivityCode["Code465"] = "465";
    EBanqupBusinessActivityCode["Code4651"] = "4651";
    EBanqupBusinessActivityCode["Code4652"] = "4652";
    EBanqupBusinessActivityCode["Code466"] = "466";
    EBanqupBusinessActivityCode["Code4661"] = "4661";
    EBanqupBusinessActivityCode["Code4662"] = "4662";
    EBanqupBusinessActivityCode["Code4663"] = "4663";
    EBanqupBusinessActivityCode["Code4664"] = "4664";
    EBanqupBusinessActivityCode["Code4665"] = "4665";
    EBanqupBusinessActivityCode["Code4666"] = "4666";
    EBanqupBusinessActivityCode["Code4669"] = "4669";
    EBanqupBusinessActivityCode["Code467"] = "467";
    EBanqupBusinessActivityCode["Code4671"] = "4671";
    EBanqupBusinessActivityCode["Code4672"] = "4672";
    EBanqupBusinessActivityCode["Code4673"] = "4673";
    EBanqupBusinessActivityCode["Code4674"] = "4674";
    EBanqupBusinessActivityCode["Code4675"] = "4675";
    EBanqupBusinessActivityCode["Code4676"] = "4676";
    EBanqupBusinessActivityCode["Code4677"] = "4677";
    EBanqupBusinessActivityCode["Code469"] = "469";
    EBanqupBusinessActivityCode["Code4690"] = "4690";
    EBanqupBusinessActivityCode["Code471"] = "471";
    EBanqupBusinessActivityCode["Code4711"] = "4711";
    EBanqupBusinessActivityCode["Code4719"] = "4719";
    EBanqupBusinessActivityCode["Code472"] = "472";
    EBanqupBusinessActivityCode["Code4721"] = "4721";
    EBanqupBusinessActivityCode["Code4722"] = "4722";
    EBanqupBusinessActivityCode["Code4723"] = "4723";
    EBanqupBusinessActivityCode["Code4724"] = "4724";
    EBanqupBusinessActivityCode["Code4725"] = "4725";
    EBanqupBusinessActivityCode["Code4726"] = "4726";
    EBanqupBusinessActivityCode["Code4729"] = "4729";
    EBanqupBusinessActivityCode["Code473"] = "473";
    EBanqupBusinessActivityCode["Code4730"] = "4730";
    EBanqupBusinessActivityCode["Code474"] = "474";
    EBanqupBusinessActivityCode["Code4741"] = "4741";
    EBanqupBusinessActivityCode["Code4742"] = "4742";
    EBanqupBusinessActivityCode["Code4743"] = "4743";
    EBanqupBusinessActivityCode["Code475"] = "475";
    EBanqupBusinessActivityCode["Code4751"] = "4751";
    EBanqupBusinessActivityCode["Code4752"] = "4752";
    EBanqupBusinessActivityCode["Code4753"] = "4753";
    EBanqupBusinessActivityCode["Code4754"] = "4754";
    EBanqupBusinessActivityCode["Code4759"] = "4759";
    EBanqupBusinessActivityCode["Code476"] = "476";
    EBanqupBusinessActivityCode["Code4761"] = "4761";
    EBanqupBusinessActivityCode["Code4762"] = "4762";
    EBanqupBusinessActivityCode["Code4763"] = "4763";
    EBanqupBusinessActivityCode["Code4764"] = "4764";
    EBanqupBusinessActivityCode["Code4765"] = "4765";
    EBanqupBusinessActivityCode["Code477"] = "477";
    EBanqupBusinessActivityCode["Code4771"] = "4771";
    EBanqupBusinessActivityCode["Code4772"] = "4772";
    EBanqupBusinessActivityCode["Code4773"] = "4773";
    EBanqupBusinessActivityCode["Code4774"] = "4774";
    EBanqupBusinessActivityCode["Code4775"] = "4775";
    EBanqupBusinessActivityCode["Code4776"] = "4776";
    EBanqupBusinessActivityCode["Code4777"] = "4777";
    EBanqupBusinessActivityCode["Code4778"] = "4778";
    EBanqupBusinessActivityCode["Code4779"] = "4779";
    EBanqupBusinessActivityCode["Code478"] = "478";
    EBanqupBusinessActivityCode["Code4781"] = "4781";
    EBanqupBusinessActivityCode["Code4782"] = "4782";
    EBanqupBusinessActivityCode["Code4789"] = "4789";
    EBanqupBusinessActivityCode["Code479"] = "479";
    EBanqupBusinessActivityCode["Code4791"] = "4791";
    EBanqupBusinessActivityCode["Code4799"] = "4799";
    EBanqupBusinessActivityCode["Code491"] = "491";
    EBanqupBusinessActivityCode["Code4910"] = "4910";
    EBanqupBusinessActivityCode["Code492"] = "492";
    EBanqupBusinessActivityCode["Code4920"] = "4920";
    EBanqupBusinessActivityCode["Code493"] = "493";
    EBanqupBusinessActivityCode["Code4931"] = "4931";
    EBanqupBusinessActivityCode["Code4932"] = "4932";
    EBanqupBusinessActivityCode["Code4939"] = "4939";
    EBanqupBusinessActivityCode["Code494"] = "494";
    EBanqupBusinessActivityCode["Code4941"] = "4941";
    EBanqupBusinessActivityCode["Code4942"] = "4942";
    EBanqupBusinessActivityCode["Code495"] = "495";
    EBanqupBusinessActivityCode["Code4950"] = "4950";
    EBanqupBusinessActivityCode["Code501"] = "501";
    EBanqupBusinessActivityCode["Code5010"] = "5010";
    EBanqupBusinessActivityCode["Code502"] = "502";
    EBanqupBusinessActivityCode["Code5020"] = "5020";
    EBanqupBusinessActivityCode["Code503"] = "503";
    EBanqupBusinessActivityCode["Code5030"] = "5030";
    EBanqupBusinessActivityCode["Code504"] = "504";
    EBanqupBusinessActivityCode["Code5040"] = "5040";
    EBanqupBusinessActivityCode["Code511"] = "511";
    EBanqupBusinessActivityCode["Code5110"] = "5110";
    EBanqupBusinessActivityCode["Code512"] = "512";
    EBanqupBusinessActivityCode["Code5121"] = "5121";
    EBanqupBusinessActivityCode["Code5123"] = "5122";
    EBanqupBusinessActivityCode["Code521"] = "521";
    EBanqupBusinessActivityCode["Code5210"] = "5210";
    EBanqupBusinessActivityCode["Code522"] = "522";
    EBanqupBusinessActivityCode["Code5221"] = "5221";
    EBanqupBusinessActivityCode["Code5222"] = "5222";
    EBanqupBusinessActivityCode["Code5223"] = "5223";
    EBanqupBusinessActivityCode["Code5224"] = "5224";
    EBanqupBusinessActivityCode["Code5229"] = "5229";
    EBanqupBusinessActivityCode["Code531"] = "531";
    EBanqupBusinessActivityCode["Code5310"] = "5310";
    EBanqupBusinessActivityCode["Code532"] = "532";
    EBanqupBusinessActivityCode["Code5320"] = "5320";
    EBanqupBusinessActivityCode["Code551"] = "551";
    EBanqupBusinessActivityCode["Code5510"] = "5510";
    EBanqupBusinessActivityCode["Code552"] = "552";
    EBanqupBusinessActivityCode["Code5520"] = "5520";
    EBanqupBusinessActivityCode["Code553"] = "553";
    EBanqupBusinessActivityCode["Code5530"] = "5530";
    EBanqupBusinessActivityCode["Code559"] = "559";
    EBanqupBusinessActivityCode["Code5590"] = "5590";
    EBanqupBusinessActivityCode["Code561"] = "561";
    EBanqupBusinessActivityCode["Code5610"] = "5610";
    EBanqupBusinessActivityCode["Code562"] = "562";
    EBanqupBusinessActivityCode["Code5621"] = "5621";
    EBanqupBusinessActivityCode["Code5629"] = "5629";
    EBanqupBusinessActivityCode["Code563"] = "563";
    EBanqupBusinessActivityCode["Code5630"] = "5630";
    EBanqupBusinessActivityCode["Code581"] = "581";
    EBanqupBusinessActivityCode["Code5811"] = "5811";
    EBanqupBusinessActivityCode["Code5812"] = "5812";
    EBanqupBusinessActivityCode["Code5813"] = "5813";
    EBanqupBusinessActivityCode["Code5814"] = "5814";
    EBanqupBusinessActivityCode["Code5819"] = "5819";
    EBanqupBusinessActivityCode["Code582"] = "582";
    EBanqupBusinessActivityCode["Code5821"] = "5821";
    EBanqupBusinessActivityCode["Code5829"] = "5829";
    EBanqupBusinessActivityCode["Code591"] = "591";
    EBanqupBusinessActivityCode["Code5911"] = "5911";
    EBanqupBusinessActivityCode["Code5912"] = "5912";
    EBanqupBusinessActivityCode["Code5913"] = "5913";
    EBanqupBusinessActivityCode["Code5914"] = "5914";
    EBanqupBusinessActivityCode["Code592"] = "592";
    EBanqupBusinessActivityCode["Code5920"] = "5920";
    EBanqupBusinessActivityCode["Code601"] = "601";
    EBanqupBusinessActivityCode["Code6010"] = "6010";
    EBanqupBusinessActivityCode["Code602"] = "602";
    EBanqupBusinessActivityCode["Code6020"] = "6020";
    EBanqupBusinessActivityCode["Code611"] = "611";
    EBanqupBusinessActivityCode["Code6110"] = "6110";
    EBanqupBusinessActivityCode["Code612"] = "612";
    EBanqupBusinessActivityCode["Code6120"] = "6120";
    EBanqupBusinessActivityCode["Code613"] = "613";
    EBanqupBusinessActivityCode["Code6130"] = "6130";
    EBanqupBusinessActivityCode["Code619"] = "619";
    EBanqupBusinessActivityCode["Code6190"] = "6190";
    EBanqupBusinessActivityCode["Code620"] = "620";
    EBanqupBusinessActivityCode["Code6201"] = "6201";
    EBanqupBusinessActivityCode["Code6202"] = "6202";
    EBanqupBusinessActivityCode["Code6203"] = "6203";
    EBanqupBusinessActivityCode["Code6209"] = "6209";
    EBanqupBusinessActivityCode["Code631"] = "631";
    EBanqupBusinessActivityCode["Code6311"] = "6311";
    EBanqupBusinessActivityCode["Code6312"] = "6312";
    EBanqupBusinessActivityCode["Code639"] = "639";
    EBanqupBusinessActivityCode["Code6391"] = "6391";
    EBanqupBusinessActivityCode["Code6399"] = "6399";
    EBanqupBusinessActivityCode["Code641"] = "641";
    EBanqupBusinessActivityCode["Code6411"] = "6411";
    EBanqupBusinessActivityCode["Code6419"] = "6419";
    EBanqupBusinessActivityCode["Code642"] = "642";
    EBanqupBusinessActivityCode["Code6420"] = "6420";
    EBanqupBusinessActivityCode["Code643"] = "643";
    EBanqupBusinessActivityCode["Code6430"] = "6430";
    EBanqupBusinessActivityCode["Code649"] = "649";
    EBanqupBusinessActivityCode["Code6491"] = "6491";
    EBanqupBusinessActivityCode["Code6492"] = "6492";
    EBanqupBusinessActivityCode["Code6499"] = "6499";
    EBanqupBusinessActivityCode["Code651"] = "651";
    EBanqupBusinessActivityCode["Code6511"] = "6511";
    EBanqupBusinessActivityCode["Code6512"] = "6512";
    EBanqupBusinessActivityCode["Code652"] = "652";
    EBanqupBusinessActivityCode["Code6520"] = "6520";
    EBanqupBusinessActivityCode["Code653"] = "653";
    EBanqupBusinessActivityCode["Code6530"] = "6530";
    EBanqupBusinessActivityCode["Code661"] = "661";
    EBanqupBusinessActivityCode["Code6611"] = "6611";
    EBanqupBusinessActivityCode["Code6612"] = "6612";
    EBanqupBusinessActivityCode["Code6619"] = "6619";
    EBanqupBusinessActivityCode["Code662"] = "662";
    EBanqupBusinessActivityCode["Code6621"] = "6621";
    EBanqupBusinessActivityCode["Code6622"] = "6622";
    EBanqupBusinessActivityCode["Code6629"] = "6629";
    EBanqupBusinessActivityCode["Code663"] = "663";
    EBanqupBusinessActivityCode["Code6630"] = "6630";
    EBanqupBusinessActivityCode["Code681"] = "681";
    EBanqupBusinessActivityCode["Code6810"] = "6810";
    EBanqupBusinessActivityCode["Code682"] = "682";
    EBanqupBusinessActivityCode["Code6820"] = "6820";
    EBanqupBusinessActivityCode["Code683"] = "683";
    EBanqupBusinessActivityCode["Code6831"] = "6831";
    EBanqupBusinessActivityCode["Code6832"] = "6832";
    EBanqupBusinessActivityCode["Code691"] = "691";
    EBanqupBusinessActivityCode["Code6910"] = "6910";
    EBanqupBusinessActivityCode["Code692"] = "692";
    EBanqupBusinessActivityCode["Code6920"] = "6920";
    EBanqupBusinessActivityCode["Code701"] = "701";
    EBanqupBusinessActivityCode["Code7010"] = "7010";
    EBanqupBusinessActivityCode["Code702"] = "702";
    EBanqupBusinessActivityCode["Code7021"] = "7021";
    EBanqupBusinessActivityCode["Code7022"] = "7022";
    EBanqupBusinessActivityCode["Code711"] = "711";
    EBanqupBusinessActivityCode["Code7111"] = "7111";
    EBanqupBusinessActivityCode["Code7112"] = "7112";
    EBanqupBusinessActivityCode["Code712"] = "712";
    EBanqupBusinessActivityCode["Code7120"] = "7120";
    EBanqupBusinessActivityCode["Code721"] = "721";
    EBanqupBusinessActivityCode["Code7211"] = "7211";
    EBanqupBusinessActivityCode["Code7219"] = "7219";
    EBanqupBusinessActivityCode["Code722"] = "722";
    EBanqupBusinessActivityCode["Code7220"] = "7220";
    EBanqupBusinessActivityCode["Code731"] = "731";
    EBanqupBusinessActivityCode["Code7311"] = "7311";
    EBanqupBusinessActivityCode["Code7312"] = "7312";
    EBanqupBusinessActivityCode["Code732"] = "732";
    EBanqupBusinessActivityCode["Code7320"] = "7320";
    EBanqupBusinessActivityCode["Code741"] = "741";
    EBanqupBusinessActivityCode["Code7410"] = "7410";
    EBanqupBusinessActivityCode["Code742"] = "742";
    EBanqupBusinessActivityCode["Code7420"] = "7420";
    EBanqupBusinessActivityCode["Code743"] = "743";
    EBanqupBusinessActivityCode["Code7430"] = "7430";
    EBanqupBusinessActivityCode["Code749"] = "749";
    EBanqupBusinessActivityCode["Code7490"] = "7490";
    EBanqupBusinessActivityCode["Code750"] = "750";
    EBanqupBusinessActivityCode["Code7500"] = "7500";
    EBanqupBusinessActivityCode["Code771"] = "771";
    EBanqupBusinessActivityCode["Code7711"] = "7711";
    EBanqupBusinessActivityCode["Code7712"] = "7712";
    EBanqupBusinessActivityCode["Code772"] = "772";
    EBanqupBusinessActivityCode["Code7721"] = "7721";
    EBanqupBusinessActivityCode["Code7722"] = "7722";
    EBanqupBusinessActivityCode["Code7729"] = "7729";
    EBanqupBusinessActivityCode["Code773"] = "773";
    EBanqupBusinessActivityCode["Code7731"] = "7731";
    EBanqupBusinessActivityCode["Code7732"] = "7732";
    EBanqupBusinessActivityCode["Code7733"] = "7733";
    EBanqupBusinessActivityCode["Code7734"] = "7734";
    EBanqupBusinessActivityCode["Code7735"] = "7735";
    EBanqupBusinessActivityCode["Code7739"] = "7739";
    EBanqupBusinessActivityCode["Code774"] = "774";
    EBanqupBusinessActivityCode["Code7740"] = "7740";
    EBanqupBusinessActivityCode["Code781"] = "781";
    EBanqupBusinessActivityCode["Code7810"] = "7810";
    EBanqupBusinessActivityCode["Code782"] = "782";
    EBanqupBusinessActivityCode["Code7820"] = "7820";
    EBanqupBusinessActivityCode["Code783"] = "783";
    EBanqupBusinessActivityCode["Code7830"] = "7830";
    EBanqupBusinessActivityCode["Code791"] = "791";
    EBanqupBusinessActivityCode["Code7911"] = "7911";
    EBanqupBusinessActivityCode["Code7912"] = "7912";
    EBanqupBusinessActivityCode["Code799"] = "799";
    EBanqupBusinessActivityCode["Code7990"] = "7990";
    EBanqupBusinessActivityCode["Code801"] = "801";
    EBanqupBusinessActivityCode["Code8010"] = "8010";
    EBanqupBusinessActivityCode["Code802"] = "802";
    EBanqupBusinessActivityCode["Code8020"] = "8020";
    EBanqupBusinessActivityCode["Code803"] = "803";
    EBanqupBusinessActivityCode["Code8030"] = "8030";
    EBanqupBusinessActivityCode["Code811"] = "811";
    EBanqupBusinessActivityCode["Code8110"] = "8110";
    EBanqupBusinessActivityCode["Code812"] = "812";
    EBanqupBusinessActivityCode["Code8121"] = "8121";
    EBanqupBusinessActivityCode["Code8122"] = "8122";
    EBanqupBusinessActivityCode["Code8129"] = "8129";
    EBanqupBusinessActivityCode["Code813"] = "813";
    EBanqupBusinessActivityCode["Code8130"] = "8130";
    EBanqupBusinessActivityCode["Code821"] = "821";
    EBanqupBusinessActivityCode["Code8211"] = "8211";
    EBanqupBusinessActivityCode["Code8219"] = "8219";
    EBanqupBusinessActivityCode["Code822"] = "822";
    EBanqupBusinessActivityCode["Code8220"] = "8220";
    EBanqupBusinessActivityCode["Code823"] = "823";
    EBanqupBusinessActivityCode["Code8230"] = "8230";
    EBanqupBusinessActivityCode["Code829"] = "829";
    EBanqupBusinessActivityCode["Code8291"] = "8291";
    EBanqupBusinessActivityCode["Code8292"] = "8292";
    EBanqupBusinessActivityCode["Code8299"] = "8299";
    EBanqupBusinessActivityCode["Code841"] = "841";
    EBanqupBusinessActivityCode["Code8411"] = "8411";
    EBanqupBusinessActivityCode["Code8412"] = "8412";
    EBanqupBusinessActivityCode["Code8413"] = "8413";
    EBanqupBusinessActivityCode["Code842"] = "842";
    EBanqupBusinessActivityCode["Code8421"] = "8421";
    EBanqupBusinessActivityCode["Code8422"] = "8422";
    EBanqupBusinessActivityCode["Code8423"] = "8423";
    EBanqupBusinessActivityCode["Code8424"] = "8424";
    EBanqupBusinessActivityCode["Code8425"] = "8425";
    EBanqupBusinessActivityCode["Code843"] = "843";
    EBanqupBusinessActivityCode["Code8430"] = "8430";
    EBanqupBusinessActivityCode["Code851"] = "851";
    EBanqupBusinessActivityCode["Code8510"] = "8510";
    EBanqupBusinessActivityCode["Code852"] = "852";
    EBanqupBusinessActivityCode["Code8520"] = "8520";
    EBanqupBusinessActivityCode["Code853"] = "853";
    EBanqupBusinessActivityCode["Code8531"] = "8531";
    EBanqupBusinessActivityCode["Code8532"] = "8532";
    EBanqupBusinessActivityCode["Code854"] = "854";
    EBanqupBusinessActivityCode["Code8541"] = "8541";
    EBanqupBusinessActivityCode["Code8542"] = "8542";
    EBanqupBusinessActivityCode["Code855"] = "855";
    EBanqupBusinessActivityCode["Code8551"] = "8551";
    EBanqupBusinessActivityCode["Code8552"] = "8552";
    EBanqupBusinessActivityCode["Code8553"] = "8553";
    EBanqupBusinessActivityCode["Code8559"] = "8559";
    EBanqupBusinessActivityCode["Code856"] = "856";
    EBanqupBusinessActivityCode["Code8560"] = "8560";
    EBanqupBusinessActivityCode["Code861"] = "861";
    EBanqupBusinessActivityCode["Code8610"] = "8610";
    EBanqupBusinessActivityCode["Code862"] = "862";
    EBanqupBusinessActivityCode["Code8621"] = "8621";
    EBanqupBusinessActivityCode["Code8622"] = "8622";
    EBanqupBusinessActivityCode["Code8623"] = "8623";
    EBanqupBusinessActivityCode["Code869"] = "869";
    EBanqupBusinessActivityCode["Code8690"] = "8690";
    EBanqupBusinessActivityCode["Code871"] = "871";
    EBanqupBusinessActivityCode["Code8710"] = "8710";
    EBanqupBusinessActivityCode["Code872"] = "872";
    EBanqupBusinessActivityCode["Code8720"] = "8720";
    EBanqupBusinessActivityCode["Code873"] = "873";
    EBanqupBusinessActivityCode["Code8730"] = "8730";
    EBanqupBusinessActivityCode["Code879"] = "879";
    EBanqupBusinessActivityCode["Code8790"] = "8790";
    EBanqupBusinessActivityCode["Code881"] = "881";
    EBanqupBusinessActivityCode["Code8810"] = "8810";
    EBanqupBusinessActivityCode["Code889"] = "889";
    EBanqupBusinessActivityCode["Code8891"] = "8891";
    EBanqupBusinessActivityCode["Code8899"] = "8899";
    EBanqupBusinessActivityCode["Code900"] = "900";
    EBanqupBusinessActivityCode["Code9001"] = "9001";
    EBanqupBusinessActivityCode["Code9002"] = "9002";
    EBanqupBusinessActivityCode["Code9003"] = "9003";
    EBanqupBusinessActivityCode["Code9004"] = "9004";
    EBanqupBusinessActivityCode["Code910"] = "910";
    EBanqupBusinessActivityCode["Code9101"] = "9101";
    EBanqupBusinessActivityCode["Code9102"] = "9102";
    EBanqupBusinessActivityCode["Code9103"] = "9103";
    EBanqupBusinessActivityCode["Code9104"] = "9104";
    EBanqupBusinessActivityCode["Code920"] = "920";
    EBanqupBusinessActivityCode["Code9200"] = "9200";
    EBanqupBusinessActivityCode["Code931"] = "931";
    EBanqupBusinessActivityCode["Code9311"] = "9311";
    EBanqupBusinessActivityCode["Code9312"] = "9312";
    EBanqupBusinessActivityCode["Code9313"] = "9313";
    EBanqupBusinessActivityCode["Code9319"] = "9319";
    EBanqupBusinessActivityCode["Code932"] = "932";
    EBanqupBusinessActivityCode["Code9321"] = "9321";
    EBanqupBusinessActivityCode["Code9329"] = "9329";
    EBanqupBusinessActivityCode["Code941"] = "941";
    EBanqupBusinessActivityCode["Code9411"] = "9411";
    EBanqupBusinessActivityCode["Code9412"] = "9412";
    EBanqupBusinessActivityCode["Code942"] = "942";
    EBanqupBusinessActivityCode["Code9420"] = "9420";
    EBanqupBusinessActivityCode["Code949"] = "949";
    EBanqupBusinessActivityCode["Code9491"] = "9491";
    EBanqupBusinessActivityCode["Code9492"] = "9492";
    EBanqupBusinessActivityCode["Code9499"] = "9499";
    EBanqupBusinessActivityCode["Code951"] = "951";
    EBanqupBusinessActivityCode["Code9511"] = "9511";
    EBanqupBusinessActivityCode["Code9512"] = "9512";
    EBanqupBusinessActivityCode["Code952"] = "952";
    EBanqupBusinessActivityCode["Code9521"] = "9521";
    EBanqupBusinessActivityCode["Code9522"] = "9522";
    EBanqupBusinessActivityCode["Code9523"] = "9523";
    EBanqupBusinessActivityCode["Code9524"] = "9524";
    EBanqupBusinessActivityCode["Code9525"] = "9525";
    EBanqupBusinessActivityCode["Code9529"] = "9529";
    EBanqupBusinessActivityCode["Code960"] = "960";
    EBanqupBusinessActivityCode["Code9601"] = "9601";
    EBanqupBusinessActivityCode["Code9602"] = "9602";
    EBanqupBusinessActivityCode["Code9603"] = "9603";
    EBanqupBusinessActivityCode["Code9604"] = "9604";
    EBanqupBusinessActivityCode["Code9609"] = "9609";
    EBanqupBusinessActivityCode["Code970"] = "970";
    EBanqupBusinessActivityCode["Code9700"] = "9700";
    EBanqupBusinessActivityCode["Code981"] = "981";
    EBanqupBusinessActivityCode["Code9810"] = "9810";
    EBanqupBusinessActivityCode["Code982"] = "982";
    EBanqupBusinessActivityCode["Code9820"] = "9820";
    EBanqupBusinessActivityCode["Code990"] = "990";
    EBanqupBusinessActivityCode["Code9900"] = "9900";
})(EBanqupBusinessActivityCode || (EBanqupBusinessActivityCode = {}));
export var BANQUP_BUSINESS_ACTIVITY_CODES = Object.values(EBanqupBusinessActivityCode);
// cspell:disable
export var BANQUP_LEGAL_FORM_CODES = [
    "0000",
    "6901",
    "LU-SECS",
    "SK-J.S.A",
    "IT-SAA",
    "NL-MT",
    "8410",
    "6596",
    "6597",
    "NL-VOF",
    "HR-TP",
    "2310",
    "HR-DD",
    "DE-KG",
    "IT-SRL",
    "HR-UST",
    "NL-NV",
    "HR-OBRT",
    "8420",
    "BE-CV",
    "2320",
    "SK-ASSOC",
    "5710",
    "DE-OHG",
    "LV-IK",
    "BG-SD/S-IE",
    "LT-KUB",
    "7340",
    "7220",
    "ES-SCI",
    "8311",
    "7344",
    "7345",
    "SK-FO",
    "1000",
    "7348",
    "RO-SCA",
    "7229",
    "5605",
    "DE-PARTG",
    "BG-ASSOC",
    "HR-GIU",
    "RO-SCS",
    "7470",
    "7230",
    "7352",
    "7111",
    "7112",
    "7113",
    "7356",
    "2220",
    "BE-EZ",
    "BG-KDA",
    "5615",
    "LT-AB",
    "2900",
    "LV-KS",
    "NL-FOUND",
    "8450",
    "7120",
    "7363",
    "9300",
    "7365",
    "7366",
    "7367",
    "2110",
    "5620",
    "5622",
    "3205",
    "5505",
    "BG-AD",
    "RO-IF",
    "IT-COOP",
    "RO-II",
    "5191",
    "5192",
    "LV-SOU",
    "PT-SA",
    "5195",
    "5196",
    "HR-ZAD",
    "2120",
    "5630",
    "5510",
    "5632",
    "NL-BV",
    "5515",
    "2800",
    "FR-SNC",
    "LU-SARL",
    "EE-TU",
    "7381",
    "7382",
    "7383",
    "7384",
    "7385",
    "BG-OOD",
    "3220",
    "5520",
    "5642",
    "5522",
    "EE-MTU",
    "NL-CV",
    "5525",
    "5647",
    "5648",
    "FR-SA-D",
    "PT-ASSOC",
    "EE-UU",
    "DE-AG",
    "7150",
    "8120",
    "9210",
    "5770",
    "HR-KD",
    "5530",
    "5410",
    "5532",
    "5654",
    "5655",
    "IT-II",
    "5415",
    "5658",
    "5659",
    "LU-SARLS",
    "LU-SA",
    "8490",
    "LU-SNS",
    "8250",
    "8130",
    "9220",
    "9221",
    "9222",
    "9223",
    "5660",
    "3120",
    "5542",
    "6511",
    "9900",
    "5546",
    "5426",
    "5306",
    "5307",
    "5308",
    "5309",
    "PL-SPZOO",
    "DE-ST",
    "7171",
    "EE-FIE",
    "9230",
    "BG-ET",
    "5670",
    "LT-A",
    "5310",
    "5432",
    "5554",
    "5555",
    "HR-OPG",
    "5559",
    "FR-EI",
    "8150",
    "LV-AS",
    "5560",
    "4110",
    "SK-A.S.",
    "DE-UG",
    "6533",
    "5203",
    "6535",
    "6536",
    "6537",
    "6538",
    "6539",
    "LU-EI",
    "FR-SARL",
    "LT-UAB",
    "DE-EK",
    "8160",
    "PT-ENI",
    "DE-GMBH",
    "5570",
    "RO-PFA",
    "6541",
    "6542",
    "5454",
    "6544",
    "5699",
    "5458",
    "5459",
    "LT-II",
    "IT-SRLS",
    "BE-VZW",
    "DE-GBR",
    "ES-SLNE",
    "8290",
    "BE-NV",
    "9260",
    "PL-SKA",
    "5460",
    "4130",
    "6551",
    "5585",
    "6554",
    "BG-EAD",
    "SK-COOP",
    "6317",
    "6318",
    "IT-SNC",
    "9150",
    "FR-ASSOC",
    "3290",
    "5470",
    "6560",
    "6561",
    "6562",
    "6563",
    "6564",
    "6565",
    "6566",
    "5599",
    "6568",
    "ES-COM",
    "ES-COS",
    "ES-SA",
    "ES-SC",
    "8190",
    "BG-COOP",
    "ES-SL",
    "6571",
    "6572",
    "6210",
    "5485",
    "6575",
    "6576",
    "6577",
    "6578",
    "BG-KD",
    "IT-SPA",
    "5800",
    "SK-V.O.S.",
    "LV-SIA",
    "RO-CA",
    "LU-SECA",
    "LU-SCOP",
    "4160",
    "9970",
    "6220",
    "8520",
    "6585",
    "7312",
    "7313",
    "PT-SNC",
    "6589",
    "6595",
    "7323",
    "BE-BV",
    "BE-VOF",
    "EE-OU",
    "7450",
    "7210",
    "RO-SRL",
    "PL-SPP",
    "PT-COMAN",
    "7341",
    "8310",
    "2210",
    "7349",
    "7351",
    "7354",
    "7355",
    "7357",
    "5610",
    "BG-EOOD",
    "PL-OFPDG",
    "7361",
    "7362",
    "7364",
    "5625",
    "SK-S.R.O.",
    "7490",
    "5193",
    "7373",
    "7378",
    "5631",
    "BE-COMMV",
    "8470",
    "8110",
    "7389",
    "5643",
    "5646",
    "FR-SA-C",
    "HR-JTD",
    "5651",
    "5531",
    "ES-AUT",
    "2700",
    "7160",
    "9224",
    "5422",
    "NL-VG",
    "5547",
    "5548",
    "LV-PS",
    "7172",
    "9110",
    "5430",
    "5553",
    "5558",
    "FR-SAS",
    "9240",
    "5442",
    "5443",
    "6534",
    "7190",
    "6540",
    "5453",
    "5455",
    "LU-SAS",
    "DE-FB",
    "8170",
    "6316",
    "4140",
    "7410",
    "RO-RA",
    "6567",
    "6569",
    "4150",
    "6573",
    "6574",
    "RO-SA",
    "HR-DOO",
    "5370",
    "6100",
    "7314",
    "3210",
    "5652",
    "5653",
    "2385",
    "3110",
    "5543",
    "5785",
    "5551",
    "5431",
    "5552",
    "6521",
    "5685",
    "5202",
    "6411",
    "6532",
    "4120",
    "5451",
    "IT-SAS",
    "6543",
    "6558",
    "8510",
    "ES-EI",
    "7430",
    "RO-SNC",
    "5499",
    "7321",
    "5385",
    "7322",
    "6599",
    "6598",
    "7331",
    "LU-ASBL",
    "7343",
    "7342",
    "7347",
    "7225",
    "7346",
    "7353",
    "LT-TUB",
    "LU-COOPSA",
    "8210",
    "DE-EV",
    "7379",
    "7372",
    "5194",
    "7371",
    "FOREIGN",
    "HR-UDR",
    "7179",
    "8140",
    "PL-SA",
    "NL-EZ",
    "BG-FOUND",
    "EE-AS",
    "SK-K.S",
    "LT-MB",
    "PT-LDA",
    "2400",
];
// cspell:enable
